<template>
  <LabelObjectSetForm ref="objectForm" :sample_id="sample_id" :label_set_id="label_set_id">
    <template v-slot:nav-buttons>
      <b-button-group>
        <b-button :disabled="loading == true" @click="previousElement()">
          <i class="fa fa-lg fa-angle-left" :class="prevIconClass" />
        </b-button>

        <b-button @click="getData()" v-model="index" v-if="loading == false">
          {{ (index != -1 ? index + 1 : "?") + " of " + list.data.length }}
        </b-button>
        <b-button v-else>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </b-button>
        <b-button :disabled="loading == true" @click="nextElement()">
          <i class="fa fa-lg fa-angle-right" :class="nextIconClass" />
        </b-button>
      </b-button-group>
    </template>
  </LabelObjectSetForm>
</template>
<script>
import { mapState } from 'vuex';
import LabelObjectSetForm from '@/views/LabelObjectSets/LabelObjectSetForm';
import Services from '@/services/index';

export default {
  props: {
    sample_id: { type: Number, default: null },
    label_set_id: { type: Number, default: null },
  },
  components: {
    LabelObjectSetForm
  },
  data() {
    return {
      loading: true,
      list: {},
      nextSampleId: null,
      index: null,
      navigationInProgress: false,
      keyDownHandler: null,
      listUpdater: null,
    };
  },
  computed: {
    params() {
      return {
        ...this.$route.query.filter ? JSON.parse(this.$route.query.filter) : {},
        light_weight: true,
        notpaginate: 1,
      };
    },

    nextIconClass() {
      const order = this.params.sort_order;
      switch (order) {
        case 'asc':
          return '';
        case 'desc':
          return 'text-dark';
        default:
          return '';
      }
    },

    prevIconClass() {
      const order = this.params.sort_order;
      switch (order) {
        case 'asc':
          return 'text-dark';
        case 'desc':
          return '';
        default:
          return '';
      }
    },

    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  mounted() {
    this.loading = true;
    this.getData();
    this.keyDownHandler = this.keydown_window.bind(this);
    window.addEventListener('keydown', this.keyDownHandler);
  },
  beforeDestroy() {
    clearTimeout(this.listUpdater);
    window.removeEventListener('keydown', this.keyDownHandler);
  },
  methods: {
    keydown_window(e) {
      if (this.navigationInProgress) { return; }

      if (e.key === 'PageUp') {
        this.nextElement();
      }
      if (e.key === 'PageDown') {
        this.previousElement();
        e.preventDefault();
      }
    },
    goTo(newIndex) {
      this.nextSampleId = this.list.data[newIndex].id;
      this.navigationInProgress = true;
      this.$router.push({
        name: 'LabelSample',
        params: { sample_id: this.nextSampleId || this.sample_id, label_set_id: this.label_set_id },
        query: { ...this.$route.query }
      }).finally(() => { this.navigationInProgress = false; });
    },
    previousElement() {
      if(this.index == -1 && this.list.data.length > 0){
        this.index = 0;
        this.goTo(this.index);
      }
      if (this.index > 0) {
        this.index--;
        this.goTo(this.index);
      }
    },
    nextElement() {
      if(this.index == -1 && this.list.data.length > 0){
        this.index = this.list.data.length - 1;
        this.goTo(this.index);
      }
      if (this.index >= 0 && this.index < this.list.data.length - 1) {
        this.index++;
        this.goTo(this.index);
      }
    },
    getData() {
      this.listUpdater = setTimeout(this.getData, 30 * 1000);
      Services.labelSets.sampleList(this.activeProjectId, this.label_set_id, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
        this.index = this.list.data.findIndex((obj) => obj.id === this.sample_id);
      }).catch((err) => { this.loading = false; console.error(err); });
    },
  },
  async beforeRouteUpdate(_to, _from, next) {
    try {
      await this.$refs.objectForm.checkForUnsavedChanges();
      next();
    } catch {
      next(false);
    }
  },
  async beforeRouteLeave(_to, _from, next) {
    try {
      await this.$refs.objectForm.checkForUnsavedChanges();
      next();
    } catch {
      next(false);
    }
  },
};

</script>
